<template>
  <div>
    <!-- 标题 -->
    <img class="dingbuimg1" src="../../static/img/ejymjpg.png" alt="" width="100%">
    <img class="dingbuimg2" src="../../static/img/ejymjpg.jpg" alt="" width="100%">
    <div class="btcss">
      <div class="tabbox">
        <div  :class="{'active':active_btn1==index}" v-for="(item,index) in xmlist" @click="newsList1(index,item)">
          <el-tooltip class="item" effect="light" :content="item.menuName" placement="top-start" >
            <span>{{item.menuName}}</span>
          </el-tooltip>
        </div>
        <div class="dqwz">首页 > {{titleName1}} > {{titleName2}}</div>
      </div>
    </div>

    <!--    <div class="tabbox" v-if="this.show">
          <div  :class="{'active':active_btn2==index}"  v-for="(item,index) in levelist" @click="newsList2(index,item)">{{item.menuName}}</div>
        </div>-->
    <div v-if="wzshow" style="width:90%;min-height: 500px;cursor: pointer">
      <img src="../../static/img/yzxckdk.jpg" v-if="!zwsj" @click="openPdf" alt="" class="yzxckdk" style="padding-left: 45%;padding-top: 10%;">
      <img src="../../static/img/zwsj.png" v-if="zwsj"  @click="openPdf" alt="" class="yzxckdk" style="padding-left: 45%;padding-top: 10%;">
    </div>
    <div class="content" >
      <div class="sanjimulu" v-if="levelist && levelist.length > 0">
        <el-tree :data="levelist" :props="defaultProps" accordion @node-click="handleNodeClick">
         <span class="custom-tree-node" slot-scope="{ node, data }" >
               <el-tooltip class="item" popper-class="btnitem" effect="light" :content="node.label" placement="bottom-end">
                 <span>{{ node.label }}</span>
               </el-tooltip>
            </span>
          <!--          <div v-for="(item,index) in levelist">{{levelist}}</div>-->
        </el-tree>
      </div>

      <div class="ceneterbox">
        <div class="lowerbox" v-if="this.listData.length > 0 ">
          <div class="cpb">
            <div class="cpbox" v-for="item in listData" @click="openDetails(item)">
              <div class="cpimg"><img :src="api + (item.productPhoto && item.productPhoto[0] ? item.productPhoto[0] : '')" class="cpimg" alt=""></div>
              <div class="cpname">
                <div>{{ item.productModel }}</div>
                <div>{{ item.productName }}</div>
                <div class="xqbox">查看详情</div>
              </div>
            </div>
          </div>
        </div>
        <P style="margin: 0px auto;" v-html="ejDetail">
        </P>
      </div>


    </div>
    <!--    <div class="content" v-if="detailsShow">
          <div v-html="ejDetail"></div>
        </div>-->

  </div>
</template>
<script>
let api = 'https://www.slfangshuijiao.com/api';
let deptId = 111;
export default {
  name: 'Ejml',
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'menuName'
      },
      queryParams: {
        pageNum: 1,
        pageSize: 12,
        type: '',
        gjz: '',
      },
      active_btn1:0,
      active_btn2:0,
      xmlist: [],
      levelist: [],
      titleName1: '',
      titleName2: '',
      ejDetail: '',
      visible: false,
      show: false,
      api,
      activeIndex: '1',
      activeIndex2: '1',
      form: {},
      rules: {},
      dataTime: '',
      columnId: '',
      imgList: [],
      columnData: [],
      outsideList: [],
      ruleForm: [],
      fileList: [],
      listData: [],
      detailsShow:true,
      wzshow:false,
      zwxx:false,
      urlIndex:'',
      titName:'',
      titleList:[
        {name:'走进神力'},
        {name:'郑重声明'},
        {name:'齐全的荣誉证照'},
        {name:'完善的资质证书'},
        {name:'企业规划优势'},
        {name:'招商优惠政策'},
      ],
    }
  },
  created() {
    if (this.$route.query.menuId){
      this.queryParams.menuId = this.$route.query.menuId
    }
    if (this.$route.query.index){
      this.urlIndex= this.$route.query.index
    }else {
      this.urlIndex= 0
    }
    this.titleName1 = this.$route.query.name
    this.target = this.$route.query.target
    // console.log(123, this.target);
    // this.listData = this.listData[this.active_btn] // 修复：active_btn 未定义，已注释掉
    console.log('下标111--',this.urlIndex);
    //首页点击城乡建设/旧城改造对应相关菜单（上）
    this.titName = this.$route.query.titName

    this.zxSubmit()
    this.lbList()

    console.log(11, this.urlIndex, this.active_btn1)
  },
  mounted() {
    if (this.$route.query.name != '产品世界') {
      this.columnId = this.$route.query.id
    }
  },
  methods: {
    handleNodeClick(data) {
      console.log(88,data);
      // if (data.menuType == 'F'){
        this.ejDetail = data.perms
      // }
      this.queryParams.menuId = data.menuId
      console.log(555,this.queryParams.menuId,this.ejDetail);
      this.zxSubmit()
    },
    //列表
    zxSubmit() {
      let that = this;
      that.$axios.post(api + '/site/productList?columnId=' + this.columnId + '&deptId=' + deptId
          + '&pageNum=' + this.queryParams.pageNum + '&pageSize=' +10000
          + '&param=' + this.queryParams.gjz+ '&parentId=' + this.queryParams.menuId, {
        emulateJSON: true
      }).then(function (res) {
        if (res.data.code == '0') {
          if (res.data.data) {
            // that.listData = res.data.data.rows
            var cpData = []
            res.data.data.rows.forEach(item => {
              if (item.parentId == that.queryParams.menuId){
                cpData.push(item)
              }
              that.listData = cpData
              item.productPhoto = item.productPhoto ? item.productPhoto.split(',') : []
              // console.log('第一个图片',item.productPhoto)
            })
            console.log('产品列表---',that.listData,res.data.data);

            that.total = res.data.data.total
          }
        } else {
          that.$message.error(res.message);
        }
      })
    },
    openPdf(){
      console.log(66,this.fileList)
      if(this.fileList && this.fileList[0] && this.fileList[0].target != ''){
        window.open(this.api  + this.fileList[0].target)
      }
    },
    newsList1(index,item){
      if(item.url!='#'){
        window.open(item.url);
        return;
      }
      this.active_btn1 = index
      this.titleName2 = item.menuName
      // this.columnId = item.menuId
      console.log('mc',item);
      this.active_btn2 = 0
      this.ejDetail = this.xmlist[this.active_btn1].perms
      this.lbList(item.parent,this.active_btn1)
      // console.log('id====',item);
      this.wzshow = false
      this.detailsShow = true
      if(item.menuType == 'C'&&item.target !=''){
        window.open(this.api  + item.target)
      }
      this.zxSubmit()
    },
    newsList2(index,item){
      let that = this;
      that.active_btn2 = index
      // console.log('数据---',that.levelist,that.active_btn2);


      // this.levesList(item.menuId,index)
      that.ejDetail = that.levelist[that.active_btn2].perms
      // console.log('id====',item.menuId,index);
    },
    //获取三级列表
    levesList(id) {
      console.log(123123,id);
      let that = this;
      that.$axios.post(api + '/site/columnList?deptId=' + deptId ,{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function(res) {
        if (res.data.code == '0') {
          // console.log('列表11',res.data.data)
          // that.levelist = res.data.data
          // that.ejDetail = res.data.data[0].perms
          if (res.data.data) {
            var arr = []
            res.data.data.forEach(item => {
              if (item.visible == 0) {
                arr.push(item)
              }
            })
            let list = that.handleTree(arr, 'menuId', 'parentId')
            console.log('树',list,that.titleName2);
            if (list){
              list.forEach(item=>{
                //判断第一级
                if (item.menuName == that.titleName1){
                  //判断第二级
                  item.children.forEach(item =>{
                    if (item.menuName == that.titleName2){
                      that.levelist = item.children;
                      // if (item){
                      //   item.children[that.urlIndex].children.forEach(item=>{
                      //     that.ejDetail = item.perms
                      //   })
                      //   /*if (that.levelist[0].children){
                      //     that.ejDetail = that.levelist[0].children[0].perms
                      //   }*/
                      //   }
                    }
                  })

                  // that.levelist = item
                }
              })
              if (that.levelist && that.levelist[that.urlIndex] && that.levelist[that.urlIndex].children && that.levelist[that.urlIndex].children[0]) {
                that.ejDetail = that.levelist[that.urlIndex].children[0].perms
              }
              console.log(666111,that.levelist,that.ejDetail);

            }
            // console.log(222,this.levelist);
            // that.ejDetail = that.levelist[0].perms
          }
        } else {
          that.$message.error(res.message);
        }
      })

    },
    // 栏目详情
    menuList(id, name) {
      let that = this;
      id = this.$route.query.id
      that.$axios.post(api + '/site/columnDetail' , {
        columnId: id
      },{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        if (res.data.code == '0') {
          // console.log(res.data.data.length)
          if (res.data.data.length > 0) {
            let type = res.data.data[0].menuType
            // console.log('详情', type)
            if (type === 'M') {
              window.location = "/#/ejml2?id=" + id + '&name=' + encodeURI(name)
            } else if (type === 'D') {
              window.location = "/#/cpDetails?id=" + id + '&name=' + encodeURI(name)
            } else if (type === 'F') {
              window.location = "/#/xiangqing?id=" + id + '&name=' + encodeURI(name)
            }
          }
        } else {
          that.$message.error(res.message);
        }
      })

    },
    openUrl(item) {
      if (item.menuName != "首页") {
        window.location = '/#/ejml?id=' + item.menuId + '&name=' + encodeURI(item.menuName);
        // window.location='/#/ejml?id=' + item.menuId
      } else {
        window.location = '/#/';
      }
    },
    //获取列表
    lbList(ids,index) {
      let that = this;
      var id
      if (ids){
        id = ids
      }else {
        id = this.$route.query.id
      }

      that.$axios.post(api + '/site/columnDetail' , {
        columnId: id
      },{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        if (res.data.code == '0') {
          if (!ids){
            that.xmlist = res.data.data
            console.log('数据111',that.xmlist);
            //首页和导航栏点击跳转
            if (index == undefined){
              if (that.urlIndex && that.titName){
                that.xmlist.forEach((item,indexs)=>{
                  console.log('ccc',item, indexs);
                  if (item.menuName == that.titName){
                    that.active_btn1 = indexs
                  }
                })
              }else {
                that.active_btn1 = that.$route.query.index
              }
            }

            //有值代表是从首页点进来的
            /*if (that.titName){
              that.xmlist.forEach((item,index)=>{
                if (item.menuName == that.titName){
                  that.active_btn1 = index

                }
              })
            }*/
          }
          //c新窗口打开时获取值
          that.fileList = res.data.data
          // console.log('文件数据',that.fileList);
          if (res.data.data){
            // that.ejDetail = res.data.data[0].perms
            // console.log('详情获取urlIndex',that.urlIndex);
            if (index == undefined){
              that.ejDetail = res.data.data[0].perms
              that.titleName2 = that.titName
              console.log('下标',index,that.ejDetail,res.data.data);
            }else if(index>=1 && res.data.data.length > index){
              that.ejDetail = res.data.data[index].perms
              that.titleName2 = res.data.data[index].menuName
            }else {
              that.ejDetail = res.data.data[0].perms
              that.titleName2 = res.data.data[0].menuName
            }
            that.show = false;
            console.log('titleName2',that.titleName2);
            // that.levesList(that.xmlist[that.active_btn1].menuId)

            if (that.xmlist[that.active_btn1].menuType === 'M'){
              that.show = true
              // console.log(123,that.xmlist[that.active_btn1].menuId,that.titleName2);
              that.levesList(that.xmlist[that.active_btn1].menuId)
            }else{
              that.levelist = []
            }
            // console.log('类型----',that.xmlist[that.active_btn1].menuType);
            if (that.xmlist[that.active_btn1].menuType === 'C'){
              that.wzshow = true
              that.detailsShow = false
              if(that.fileList && that.fileList[0] && that.fileList[0].target !=''){
                that.zwsj=false;
              }else {
                that.zwsj=true;
              }
            }else {
              that.wzshow = false
              that.detailsShow = true
            }
          }
        } else {
          that.$message.error(res.message);
        }
      })

    },
    //跳转产品详情页面
    openDetails(item) {
     // console.log(999,item);
      window.location = "/#/cpdetails?id=" + item.productId + '&name=' + encodeURI(item.productName) +
          '&index=' +  this.active_btn1 + '&menuId=' + this.columnId
    },
    // openDetails(item) {
    //   // window.open("/#/ejml2")
    //   console.log(222, item)
    //   if (item.menuType === 'M') {
    //     window.location = "/#/ejml2?id=" + item.menuId + '&name=' + encodeURI(item.menuName)
    //   } else if (item.menuType === 'D') {
    //     window.location = "/#/cplist?id=" + item.menuId + '&name=' + encodeURI(item.menuName)
    //   } else if (item.menuType === 'F') {
    //     window.location = "/#/xiangqing?id=" + item.menuId + '&name=' + encodeURI(item.menuName)
    //   }
    // },
    //获取url
    GetQueryString(str) {
      var reg = new RegExp("(^|&)" + str + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]);
      return null;
    },
    handleTree(data, id, parentId, children) {
      let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children'
      };

      var childrenListMap = {};
      var nodeIds = {};
      var tree = [];

      for (let d of data) {
        let parentId = d[config.parentId];
        if (childrenListMap[parentId] == null) {
          childrenListMap[parentId] = [];
        }
        nodeIds[d[config.id]] = d;
        childrenListMap[parentId].push(d);
      }

      for (let d of data) {
        let parentId = d[config.parentId];
        if (nodeIds[parentId] == null) {
          tree.push(d);
        }
      }

      for (let t of tree) {
        adaptToChildrenList(t);
      }

      function adaptToChildrenList(o) {
        if (childrenListMap[o[config.id]] !== null) {
          o[config.childrenList] = childrenListMap[o[config.id]];
        }
        if (o[config.childrenList]) {
          for (let c of o[config.childrenList]) {
            adaptToChildrenList(c);
          }
        }
      }

      return tree;
    },

  }
}
</script>
<style>
.custom-tooltip {
  /* 在这里写入你的定位样式 */
  top: 50px !important; /* 改变top值来调整位置 */
  left: 10px !important; /* 改变left值来调整位置 */
}
.el-tree-node__children .el-tree-node .el-tree-node__content{
  padding: 10px;
}
.el-tree>.el-tree-node>.el-tree-node__content  {
  padding: 15px;
}
.el-tree>.el-tree-node:focus>.el-tree-node__content{
  padding: 15px;
}
.el-tree>.el-tree-node>.el-tree-node__content span {
  font-size: 16px;
}

.el-tree>.el-tree-node:focus>.el-tree-node__content span{
  font-size: 16px ;

}
.dingbuimg2{
  display: none;
}
.xqbox{
  background-color: #008C3E;
  width: 30%;
  margin: auto;
  border-radius: 5px;
  margin-top:5px;
  color: #FFFFFF;
  padding: 5px 15px;
}
.ceneterbox {
  /*margin: auto;*/
  width: 100%;
  overflow: auto;
  /* margin-top: 1%!important; */
}
.container div:first-child{
  /*overflow: auto;*/
}
.lowerbox {
  padding: 25px;
  margin: 15px 0;
  overflow: hidden;
  background: #E6F3EA;
}
.cpb{
  padding: 0;
  /*display: flex;*/
  /*justify-content: center;*/
  /*overflow: auto;*/
}
.cpbox:hover {
  border: solid 2px #DEE1E6;
}

.cpbox {
  border: solid 2px #ffffff;
  width: calc(100% / 3 - 35px);
  float: left;
  margin: 10px;
  cursor: pointer;
}
.cpimg {
  height: 300px;
  width: 100%;
  object-fit: contain;
  background: #fff;
}
.cpname {
  border-top: solid 1px #E8E8E8;
  background-color: #ffffff;
  text-align: center;
  padding: 15px;
}
.el-tooltip__popper .popper__arrow, .el-tooltip__popper .popper__arrow::after{
  display: none;
}
.sanjimulu{
  margin-right: 30px;
  margin-bottom: 30px;
  padding-right: 30px;
  border-right: 1px solid rgb(110, 110, 110);
  min-width: 15%;
  /*width: 460px;*/
}

.custom-tree-node{
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.el-tree-node__label{
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.el-tree__empty-text {
  display: none;
}
.content{
  display: flex;
  width: 90%;
  margin: 30px auto 0 auto;
  min-height: 800px;
}

.yzxckdk{
  padding-left: 45%;
  padding-top: 10%;
}
/*头部*/
.dqwz{
  color: rgba(110,110,110,1);
  font-size: 14px;
  float: right;
  height: 30px;
  padding: 0 65px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.btcss{
  border-bottom:  rgba(110,110,110,1) solid 1px;
  margin-bottom: 30px;
  overflow: hidden;
  line-height: 37px;
}
.active{
  color: #008D40;
  font-weight: 600;
  border-bottom: #0dcc73 solid 3px;
}
.tabbox div{
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  min-width: 80px;
  cursor: pointer;
  padding: 5px 2px;
  margin-left: 20px;
}
.tabbox{
  display: flex;
  width: 93%;
  padding: 0px 15px 0 15px;
  justify-content: space-between;
  margin-left: 45px;
  float: left;
  flex-wrap: wrap;
/*justify-content:space-around;*/
/*font-weight: bold;*/
}
.flexbox {
  display: flex;
  font-size: 18px;
  padding: 10px;
  cursor: pointer;
}

.flexbox:hover {
  color: red;
}

.sjimg {
  background-color: rgb(0, 160, 233);
  -webkit-mask: url(./../../static/img/erjijiantou.svg) center center / contain no-repeat;
  width: 50px;
}

.centerbox {
  overflow: auto;
  width: 50%;
  margin: auto;
  padding: 15px;
  height: 50%;
}

body,
html {
  height: 100%;
  margin: 0;
}

#app {
  overflow: auto;
  height: 100%;
  width: 100%;
  /*background-image: url(../../static/img/939939bfb61178f5b4706ec7ed06302.jpg);*/
  background-size: 100% 100%;
}

.bt {
  background-image: url(../../static/img/3e335a61c60a1f37dbe724dd45f0090f_10121_1465_75.png);
  color: #FFFFFF;
  width: 100%;
  text-align: center;
  align-content: center;
  margin: 0;
}


.el-dialog__wrapper {
  overflow: hidden;
}

.zxbox .el-dialog {
  left: 22% !important;
  margin-top: auto !important;
}

.zxbox .el-dialog__header {
  background-color: #009FED;
  padding: 0px;
}

.zxbox .el-dialog__title {
  color: #fff;
}

.zxbox .dialog-header-title {
  display: flex;
  border-radius: 10px;
}

.zxbox .el-dialog__close {
  color: #fff;
}

.zxbox {
  top: 35%;
}

.zxname {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  line-height: 40px;
  padding: 0 5px;
  line-height: 50px;
}

.el-form-item__content {
  text-align: center;
  padding: 5px;
}

.el-form-item {
  margin-bottom: 0px;
}

.el-popover,
.popper__arrow::after {
  padding: 0px;
  border-radius: 10px;
  background-color: rgb(0, 160, 233);
  border: 1px solid rgb(0, 160, 233)
}

.zxcha {
  line-height: 40px;
  font-size: 16px;
}

.zxhead {
  display: flex;
  color: #fff;
  background-color: rgb(0, 160, 233);
  border-radius: 10px;
}
.el-tree-node {
  outline: 0;
  overflow: hidden;
}
@media screen and (max-width: 500px) {
  .xqbox{
    width: 100%;
    font-size: 12px;
    padding: 5px 0px;
  }
  .dingbuimg1{
    display: none;
  }
  .dingbuimg2{
    display: block;
  }
  .tabbox {
    padding: 0px 15px 0 15px !important;
    margin-left: -10px !important;
    max-height: 200px;
    overflow: auto;
  }
  .tabbox div {
    margin-left: 10px;
  }
  .yzxckdk{
    padding-left: 12% !important;
  }
  .content{
    min-height: 500px;
    display: block;
  }
  .sanjimulu{
    margin-right: 30px;
    margin-bottom: 30px;
    padding-bottom: 30px;
    border-bottom: 1px solid rgb(110, 110, 110);
    border-right:none;
    max-width: 100%;
  }
  .tabbox div{
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    min-width: 80px;
    cursor: pointer;
    padding: 5px 2px;
    margin-left: 20px;
    text-align:inherit!important;
    width: calc(100%/4 - 50px)!important;
  }
}
</style>
